import { Check } from '@untitledui/icons'
import { cx } from '@/utils/cx'

/**
 * Was etwas mitbringt — und was nicht.
 *
 * **Beides, nicht nur das Enthaltene.** Der Unterschied zwischen zwei Rollen
 * oder zwei Editionen *ist* gerade das, was jeweils fehlt; eine Liste, die nur
 * das Erlaubte zeigt, lässt ihn nicht erkennen. Deshalb stehen immer alle
 * Zeilen da, die fehlenden durchgestrichen.
 *
 * Steht neben der Auswahl, die sie beschreibt, und ändert sich mit ihr. Im
 * Auswahlfeld selbst hätte der Text keinen Platz — genau daran war die
 * Rollenauswahl vorher unlesbar.
 *
 * Die Farbe trägt die Aussage nicht allein: Haken und Strich sind auch ohne
 * Farbe unterscheidbar, und für Vorleseprogramme steht es im Text.
 */

export interface Merkmal {
  name: string
  enthalten: boolean
  /** Kurzer Nachsatz, etwa „geplant" für Zugesagtes, das noch nicht läuft. */
  zusatz?: string
}

export function Merkmalsliste({ titel, merkmale }: { titel: string; merkmale: Merkmal[] }) {
  return (
    <aside className="h-fit rounded-xl border border-secondary bg-secondary p-4">
      <p className="text-[11.5px] font-medium text-quaternary">{titel}</p>
      <ul className="mt-2.5 flex flex-col gap-2">
        {merkmale.map((m) => (
          <li key={m.name} className="flex items-start gap-2">
            {m.enthalten ? (
              <Check
                aria-hidden="true"
                className="mt-px size-3.5 shrink-0 stroke-[2.5px] text-fg-success-primary"
              />
            ) : (
              <span aria-hidden="true" className="mt-[7px] h-px w-3.5 shrink-0 bg-border-primary" />
            )}
            <span
              className={cx(
                'text-[12.5px] leading-snug',
                m.enthalten ? 'text-primary' : 'text-quaternary line-through decoration-1',
              )}
            >
              <span className="sr-only">{m.enthalten ? 'Enthalten: ' : 'Nicht enthalten: '}</span>
              {m.name}
              {m.zusatz ? (
                <span className="ml-1.5 text-[11px] text-quaternary no-underline">{m.zusatz}</span>
              ) : null}
            </span>
          </li>
        ))}
      </ul>
    </aside>
  )
}
